import { Config } from 'driver.js'

export const TOUR_STORAGE_KEY = 'mdt_tour_completed'

export const dashboardTourSteps: Config['steps'] = [
	{
		element: '[data-tour="nav-locations"]',
		popover: {
			title: 'Locations',
			description:
				'Your properties live here. Add, view, and manage all your commercial real estate locations.',
			side: 'right',
			align: 'start',
		},
	},
	{
		element: '[data-tour="nav-projects"]',
		popover: {
			title: 'Projects',
			description:
				'Projects are linked to locations. Track deals from site selection to close.',
			side: 'right',
			align: 'start',
		},
	},
	{
		element: '[data-tour="nav-portfolios"]',
		popover: {
			title: 'Portfolios',
			description:
				'Group locations into portfolios by client, strategy, or region — and share them with partners.',
			side: 'right',
			align: 'start',
		},
	},
	{
		element: '[data-tour="nav-tasks"]',
		popover: {
			title: 'Tasks',
			description:
				'Manage deadlines, assignments, and milestones. View as cards, table, or calendar.',
			side: 'right',
			align: 'start',
		},
	},
	{
		element: '[data-tour="nav-partners"]',
		popover: {
			title: 'Partners',
			description:
				'Invite brokers, landlords, and contractors to collaborate. Build your professional CRE network.',
			side: 'right',
			align: 'start',
		},
	},
	{
		element: '[data-tour="nav-explorer"]',
		popover: {
			title: 'Explorer',
			description:
				'Build a spreadsheet view of any part of your portfolio. Pick the columns, filter, group, and export.',
			side: 'right',
			align: 'start',
		},
	},
	{
		// This anchor moved from the sidebar to the header when the global chat
		// became a popup. side/align follow: 'right' would point off the edge of
		// the viewport from a button in the top-right corner.
		element: '[data-tour="nav-chat"]',
		popover: {
			title: 'Messages',
			description:
				'Real-time messaging tied to your deals, from any screen. It opens right here, so you never lose your place.',
			side: 'bottom',
			align: 'end',
		},
	},
	{
		popover: {
			title: "You're All Set!",
			description:
				'Explore MYDealTeams at your own pace. You can always access all features from the sidebar.',
		},
	},
]

export const tourConfig: Partial<Config> = {
	showProgress: true,
	showButtons: ['next', 'previous', 'close'],
	steps: dashboardTourSteps,
	nextBtnText: 'Next',
	prevBtnText: 'Back',
	doneBtnText: 'Done',
	progressText: '{{current}} of {{total}}',
}
